export class CreateShareProductsLinkWsMapper {

    private static readonly SHORT_DYNAMIC_LINK_KEY = 'shortDynamicLink';

    mapFromJson(param: any): string {
        return param[CreateShareProductsLinkWsMapper.SHORT_DYNAMIC_LINK_KEY];
    }
}